import { LinkTo } from '@ember/routing';
import Component from '@glimmer/component';

interface ConditionalLinkToSignature {
  Args: {
    activeClass?: string;
    'current-when'?: string;
    condition: boolean;
    disabled?: boolean;
    model?: unknown;
    models?: unknown[];
    query?: Record<string, string>;
    replace?: boolean;
    route?: string;
  };
  Blocks: {
    default: [];
  };
  Element: HTMLSpanElement | HTMLAnchorElement;
}

export default class ConditionalLinkTo extends Component<ConditionalLinkToSignature> {
  get query(): Record<string, string> {
    return this.args.query ?? {};
  }

  get models(): unknown[] {
    if (this.args.model) {
      return [this.args.model];
    } else if (this.args.models) {
      return this.args.models;
    }
    return [];
  }

  <template>
    {{#if @condition}}
      <LinkTo
        @activeClass={{@activeClass}}
        @current-when={{@current-when}}
        @disabled={{@disabled}}
        @models={{this.models}}
        @query={{this.query}}
        @replace={{@replace}}
        @route={{@route}}
        ...attributes
      >
        {{yield}}
      </LinkTo>
    {{else}}
      <span ...attributes>
        {{yield}}
      </span>
    {{/if}}
  </template>
}
